/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

// Extended navigation item type with optional role and feature requirements
export type NavItemWithRole = FuseNavigationItem & {
    requiredRole?: string;
    requiredFeature?: string;
};

export const defaultNavigation: NavItemWithRole[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:rocket-launch',
        link: './dashboard',
    },
    {
        id: 'events',
        title: 'Events',
        type: 'basic',
        icon: 'heroicons_outline:calendar-days',
        link: './events',
    },
    {
        id: 'tickets',
        title: 'Tickets',
        type: 'basic',
        icon: 'heroicons_outline:ticket',
        link: './tickets',
        requiredRole: 'staff',
        requiredFeature: 'ticketing',
    },
    {
        id: 'advertisements',
        title: 'Advertisements',
        type: 'basic',
        icon: 'heroicons_outline:megaphone',
        link: './advertisements',
        requiredFeature: 'event-ads',
    },
    {
        id: 'feedback',
        title: 'Surveys',
        type: 'basic',
        icon: 'heroicons_outline:chat-bubble-oval-left',
        link: './feedback',
        requiredRole: 'manager',
        requiredFeature: 'surveys',
    },
    {
        id: 'organisation',
        title: 'Organization',
        type: 'basic',
        icon: 'heroicons_outline:building-office-2',
        link: './organization',
        requiredRole: 'admin',
    },
];
// Compact and futuristic layouts aren't used, but the navigation service still
// translates every variant — mirror the default nav so no item references a
// missing `nav.<id>` key (the old Fuse 'example' placeholders did).
export const compactNavigation: NavItemWithRole[] = defaultNavigation.map(
    (item) => ({ ...item })
);
export const futuristicNavigation: NavItemWithRole[] = defaultNavigation.map(
    (item) => ({ ...item })
);
//SIMON WE USE THIS ONE
export const horizontalNavigation: NavItemWithRole[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:rocket-launch',
        link: './dashboard',
    },
    {
        id: 'events',
        title: 'Events',
        type: 'basic',
        icon: 'heroicons_outline:calendar-days',
        link: './events',
    },
    {
        id: 'tickets',
        title: 'Tickets',
        type: 'basic',
        icon: 'heroicons_outline:ticket',
        link: './tickets',
        requiredRole: 'staff',
        requiredFeature: 'ticketing',
    },
    {
        id: 'advertisements',
        title: 'Advertisements',
        type: 'basic',
        icon: 'heroicons_outline:megaphone',
        link: './advertisements',
        requiredFeature: 'event-ads',
    },
    {
        id: 'feedback',
        title: 'Surveys',
        type: 'basic',
        icon: 'heroicons_outline:chat-bubble-oval-left',
        link: './feedback',
        requiredRole: 'manager',
        requiredFeature: 'surveys',
    },
    {
        id: 'organisation',
        title: 'Organization',
        type: 'basic',
        icon: 'heroicons_outline:building-office-2',
        link: './organization',
        requiredRole: 'admin',
    },
];
